import styled from 'styled-components';

const Style = styled.div`
  margin-top: var(--size-lg);
  flex: 1;
  margin-left: 0px !important;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  padding: 17px 17px 0px 17px;
  display: flex;
  flex-direction: column;
  position: relative;

  canvas {
    width: 100% !important;
  }

  .legend {
    display: flex;
    flex: 1;
    padding: 10px 0px;
    flex-wrap: wrap;

    .section {
      display: flex;
      gap: 8px;

      &.main {
        gap: 2px;
        flex: 1;
      }
      
      .amount-items {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .legend-d {
          position: relative;
          width: 40px;
          height: 39px;
          border: 1px solid black;
          padding: 0px;

          .box-a {
            padding: 0px;
            margin: 0px;
            position: absolute;
            padding: 0px;
            height: 15px;
            width: 16px;
            border: 1px solid black;
            border-left: 0px;
            border-bottom: 0px;
            bottom: 0px;
          }

          .arrow {
            position: absolute;
            width: 1px;
            margin: 0px;
            padding: 0px;
            height: 20px;
            background: black;
            right: 12px;
            top: 2px;
            transform: rotate(45deg);
          }

          .triangle {
            position: absolute;
            width: 0; 
            padding: 0px;
            margin: 0px;
            height: 0; 
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;           
            border-bottom: 3px solid black;
            top: 4px;
            right: 3px;
            transform: rotate(45deg);
          }
        }

        .values {
          display: flex;
          justify-content: space-between;

          label {
            font-size: 12px;
            font-weight: 500;
            margin-bottom: 0px;
            color: #001529;
          }
        }
      }

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 0px;
        margin-left: 0px;
        
        label {
          color: #262626;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 0px;
          margin-right: 12px;
        }

        span {
          font-size: 10px;
          color: #A4A4A4;
          font-weight: 500;
        }

        &.colors-legend {
          justify-content: space-around;
          
          div {
            width: 18px;
            height: 14px;
          }

          label {
            text-align: center;
            font-size: 12px;
            margin-bottom: 0px;
            font-weight: 500;
            color: #001529;
            margin-right: 0px;
          }
        }

        &.amount-legend {
          margin-top: 10px;
          justify-content: flex-end;
          padding-bottom: 5px;

          .i {
            border: 1px solid black;
          }

          .item-0 {
            width: 7px;
            height: 4px;
          }

          .item-25 {
            width: 14px;
            height: 8px;
          }

          .item-50 {
            width: 21px;
            height: 12px;
          }
          
          .item-75 {
            width: 28px;
            height: 16px;
          }
          
          .item-100 {
            width: 35px;
            height: 20px;
          }
        }
      }
    }
  }

  &.no-borders {
    padding: 0px;
    border: 0px;
    border-radius: 0px;

    .legend {
      padding: 30px 0px 0px 0px;
      .section {
        gap: 4px;
        .item {
          &.colors-legend {
            justify-content: space-around;

            &.legend-dp {
              div {
                background: #98A2B3;
              }
            }
            
            div {
              border-radius: 2px;
              width: 18px;
              height: 14px;
            }

            &.sm {
              div {
                width: 11px;
                height: 9px;
              }
            }

            &.md {
              div {
                width: 17px;
                height: 13px;
                margin-top: -4px;
              }
            }

            &.lg {
              div {
                width: 23px;
                height: 18px;
                margin-top: -8px;
              }
            }
          }
        }
      }
    }
  }

`;

export default Style;
